/** DataType indicates how the data is to be understood by any consuming system. */
export enum DataType {
  FORECAST = 1,
  SIMPLE_SCALAR = 2,
  AVERAGE = 5,
  MINIMUM = 6,
  ZONE_TRANSITION_TRIGGER = 10
}

/** @deprecated Use SampleStatus instead */
export enum ErrorCode {
  NO_ERROR = 0,
  MISSING_DATA = 5,
  OUT_OF_RANGE = 10
}

/** https://farmbot-au.atlassian.net/wiki/spaces/products/pages/2937126914/Status+Code+Overview+-+Definition+Logic+and+Implementation#Status-Code-Definitions */
export enum SampleStatusCode {
  OK_DATA = 0,
  NO_TX_RECEIVED = 1,
  BAD_SENSOR = 2,
  BAD_SENSOR_H = 3,
  BAD_SENSOR_L = 4,
  ABOVE_MAXIMUM = 5,
  BELOW_MINIMUM = 6
}